<template>
    <textarea class="form-control" :name="name"></textarea>
</template>

<script>
export default {
    name: 'Form-summernote',
    props: {
        model: {
            required: true
        },
        id: String,
        name: String,
        height: {
            type: String,
            default: '150'
        },
    },
    mounted() {
        let config = {
            height: this.height,
            tooltip: false
        };
        config.toolbar = [
            ['paragraphstyle', ['style', 'ul']],
            ['style', ['bold', 'italic', 'underline', 'clear']],
            ['insert', ['link']],
            ['view', ['codeview']]
        ];
        let vm = this;
        config.callbacks = {
            onInit: function() {
                $(vm.$el).summernote("code", vm.model);
            },
            onChange: function() {
                vm.$emit('update:model', $(vm.$el).summernote('code'));
            },
        };
        $(this.$el).summernote(config);
    }
}
</script>
